import { render, staticRenderFns } from "./accounts.vue?vue&type=template&id=f8686452&scoped=true"
import script from "./accounts.vue?vue&type=script&lang=js"
export * from "./accounts.vue?vue&type=script&lang=js"
import style0 from "./accounts.vue?vue&type=style&index=0&id=f8686452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8686452",
  null
  
)

export default component.exports